<template>
  <el-dialog
    title="添加备注"
    :visible.sync="addRemarkVisible"
    top="29vh"
    width="500px"
    :lock-scroll="false"
    :close-on-click-modal="false"
    @close="closeDialog"
  >
    <div v-loading="isLoading">
      <el-form
        ref="ruleForm"
        class="ruleForm"
        :model="form"
        :rules="rules"
        label-position="right"
        label-width="65px"
      >
        <el-form-item label="备注：" prop="description">
          <el-input
            v-model="form.description"
            type="textarea"
            :autosize="{ minRows: 5 }"
            placeholder=""
            maxlength="200"
            show-word-limit
            resize="none"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <p class="submit fn-text-center">
        <el-button type="primary" @click="handleCreate('ruleForm')"
          >确定</el-button
        >
      </p>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    projectRelationId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      addRemarkVisible: true,
      form: {
        description: ""
      },
      rules: {
        description: [
          {
            required: true,
            message: "备注信息不能为空",
            trigger: ["blur", "change"]
          }
        ]
      },
      isLoading: false
    };
  },
  methods: {
    // 关闭弹框后回调
    closeDialog() {
      // 传递关闭上一级
      this.$emit("close", true);
    },
    handleCreate(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadCreate();
        }
      });
    },
    loadCreate() {
      this.isLoading = true;
      this.$api("project", "addRemark", {
        projectRelationId: this.projectRelationId,
        ...this.form
      }).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.$emit("complete", true);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped></style>
